import { useMutation } from '@tanstack/react-query';
import { toast } from '@huspy/forge/shared';
import { coreApi } from '@modules/core/api';
import { AuthMethod } from '@modules/core/api/const';

export const useRequestOtp = (opportunityId: string, isResend: boolean = false) => {
  const { mutateAsync, error, isPending } = useMutation({
    mutationKey: ['request-otp'],
    mutationFn: (authMethod: AuthMethod) =>
      coreApi.requestOtp(opportunityId, isResend, authMethod),
    onError: (err) => {
      toast('error', { message: err?.message ?? 'Something went wrong' });
    },
  });

  return { error, mutateAsync, isPending };
};
